import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal, Button, Form, ListGroup, Spinner } from 'react-bootstrap';
import {
  createDiscrepancyNote,
  searchDiscrepancyNote
} from 'services/stock-location/discrepancyNoteService';
import { getUsername } from 'services/userServices';

const NotesPopup = ({ isShow, data, handleClose, handleSubmit }) => {
  const [formData, setFormData] = useState({
    newNote: '',
    notes: []
  });
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (isShow && data?.id) {
      fetchNotes(data.id);
    }
  }, [isShow, data]);

  const fetchNotes = async discrepancyId => {
    setLoading(true);
    try {
      const result = await searchDiscrepancyNote({ discrepancyId });
      console.log(result);
      setFormData(prev => ({ ...prev, notes: result.items || [] }));
    } catch (error) {
      console.error('Error fetching notes:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (key, value) => {
    setFormData(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const onSaveNote = async () => {
    if (!formData.newNote.trim() || !data?.id) return;

    setSaving(true);
    try {
      await createDiscrepancyNote({
        discrepancyId: data.id,
        note: formData.newNote.trim()
      });
      setFormData(prev => ({ ...prev, newNote: '' }));
      await fetchNotes(data.id);
      handleSubmit();
    } catch (error) {
      console.error('Error saving note:', error);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal show={isShow} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Notes</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h6 className="mb-3">Previous Notes</h6>
        {loading ? (
          <div className="text-center my-3">
            <Spinner animation="border" />
          </div>
        ) : formData.notes.length > 0 ? (
          <ListGroup
            className="mb-3"
            style={{ maxHeight: '500px', overflowY: 'auto' }}
          >
            {formData.notes.map((note, index) => (
              <ListGroup.Item key={index}>
                <div className="fw-bold">
                  {getUsername(note.createdBy) || 'User'}
                </div>
                <div>{note.note}</div>
                <small className="text-muted">
                  {note.createdAt
                    ? new Date(note.createdAt).toLocaleString()
                    : 'No date'}
                </small>
              </ListGroup.Item>
            ))}
          </ListGroup>
        ) : (
          <p className="text-muted">No notes available</p>
        )}

        <Form.Group>
          <Form.Label>Add new note</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={formData.newNote}
            onChange={e => handleChange('newNote', e.target.value)}
            placeholder="Write your note here..."
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose} disabled={saving}>
          Close
        </Button>
        <Button
          variant="primary"
          onClick={onSaveNote}
          disabled={!formData.newNote.trim() || saving}
        >
          {saving ? 'Saving...' : 'Save Note'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

NotesPopup.propTypes = {
  isShow: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  handleClose: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func
};

export default NotesPopup;
